import { connect } from 'react-redux';
import { Container } from './Table';
import * as selectDetail from '@app/src/views/CipReport/report/state/detail/selectors';
import * as selectFilterValues from '@app/src/views/CipReport/report/state/filterValues/selectors';
import * as selectOperator from '@app/src/views/CipReport/filter/state/operator/selectors';
import { fetchDetail } from '@app/src/views/CipReport/report/state/detail/actions';
import { selectedItemDetail } from '@app/src/views/CipReport/report/state/detail/actions';
import { openModal } from '@app/src/commons/modal/state/modals/actions';

const mapStateToProps = state => ({
  items: selectDetail.getItems(state),
  isFetching: selectDetail.getIsFetching(state),
  filter: selectFilterValues.getValues(state),
  message: selectOperator.getMessage(state),
  sessionRol: selectOperator.getSessionRol(state)
});

const mapDispatchToProps = dispatch => ({
  handleFetchDetail: (filter: object, url: string) => dispatch(fetchDetail(filter, url)),
  handleClickModal: () => dispatch(openModal('LIST_MODAL')),
  selectedItemDetail: (index: number) => dispatch(selectedItemDetail(index))
});

export const TableContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Container);
